import { SystemsDecorator } from "../../modules/systems";
import { System } from "./System";

export const SystemContainer = () => {
  return (
    <SystemsDecorator>
      {(system) => <System siteId={system.siteId} />}
    </SystemsDecorator>
  );
};
